module.exports = __webpack_public_path__ + "img/danger@3x.ba29f80d.png";